// extracted by mini-css-extract-plugin
export var aboveInput = "_ib-0";
export var actionButton = "_ib-5";
export var actionButtonContainer = "_ib-1";
export var actionIcon = "_ib-6";
export var aiInfoContainer = "_ib-2";
export var attachmentWrapper = "_ib-7";
export var bold = "_ib-3";
export var checkIcon = "_ib-8";
export var clickingRecipientBar = "_ib-11";
export var commentThreadSwitch = "_ib-a";
export var draftImage = "_ib-b";
export var draftImageContainer = "_ib-c";
export var draftImages = "_ib-e";
export var editButton = "_ib-g";
export var editor = "_ib-f";
export var editorContainer = "_ib-y";
export var editorErrorTooltipWrapper = "_ib-9";
export var headerDivider = "_ib-h";
export var icon = "_ib-i";
export var info = "_ib-j";
export var internal = "_ib-n";
export var internalDivider = "_ib-k";
export var internalMessage = "_ib-l";
export var messageInputCard = "_ib-m";
export var messageInputForm = "_ib-o";
export var messageInputFormInternal = "_ib-p";
export var options = "_ib-q";
export var publicMessageCustomer = "_ib-s";
export var publicMessageMerchant = "_ib-r";
export var removeImageButton = "_ib-d";
export var replyButtons = "_ib-t";
export var showSignatureButton = "_ib-u";
export var spinner = "_ib-v";
export var verticalButtonDivider = "_ib-4";
export var visibilitySelector = "_ib-w";
export var warning = "_ib-x";
export var wrappingText = "_ib-z";
export var writingInternalNoteTopBorder = "_ib-10";